import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSEO } from '../../../hooks/useSEO';

export default function ChanghuaPage() {
  useSEO({
    title: '彰化搬家公司推薦｜專業搬家服務｜彰化縣搬家費用估價 - 安心搬家',
    description: '彰化搬家公司推薦首選！提供彰化縣26鄉鎮專業搬家服務，包含彰化市、員林市、和美鎮、鹿港鎮等。24小時服務，免費估價，專業團隊，搬家零煩惱。立即預約彰化搬家服務！',
    keywords: '彰化搬家,彰化搬家公司,彰化市搬家,員林搬家,和美搬家,彰化縣搬家費用,彰化搬家推薦,彰化搬家估價,鹿港搬家,溪湖搬家',
    ogImage: 'https://public.readdy.ai/ai/img_res/d9b598f2a627cca18b2e424986c4e8fe.jpg'
  });

  useEffect(() => {
    // 加入 Schema.org LocalBusiness 結構化資料
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "安心搬家 - 彰化搬家服務",
      "image": "https://readdy.ai/api/search-image?query=professional%20moving%20service%20team%20efficiently%20loading%20furniture%20into%20truck%20in%20Changhua%20city%20residential%20area%20with%20organized%20packing%20boxes%20and%20protective%20materials%20under%20clear%20blue%20sky&width=1200&height=630&seq=changhua-moving-og-001&orientation=landscape",
      "@id": "https://moving-company.com/area/changhua",
      "url": "https://moving-company.com/area/changhua",
      "telephone": "+886-2-1234-5678",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "彰化市中正路一段",
        "addressLocality": "彰化縣",
        "postalCode": "500",
        "addressCountry": "TW"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 24.0518,
        "longitude": 120.5161
      },
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        "opens": "00:00",
        "closes": "23:59"
      },
      "sameAs": [
        "https://www.facebook.com/movingcompany",
        "https://www.instagram.com/movingcompany"
      ],
      "priceRange": "$$",
      "areaServed": [
        { "@type": "City", "name": "彰化市" },
        { "@type": "City", "name": "員林市" },
        { "@type": "City", "name": "和美鎮" },
        { "@type": "City", "name": "鹿港鎮" },
        { "@type": "City", "name": "溪湖鎮" },
        { "@type": "City", "name": "二林鎮" },
        { "@type": "City", "name": "田中鎮" },
        { "@type": "City", "name": "北斗鎮" },
        { "@type": "City", "name": "花壇鄉" },
        { "@type": "City", "name": "芬園鄉" },
        { "@type": "City", "name": "大村鄉" },
        { "@type": "City", "name": "永靖鄉" },
        { "@type": "City", "name": "伸港鄉" },
        { "@type": "City", "name": "線西鄉" },
        { "@type": "City", "name": "福興鄉" },
        { "@type": "City", "name": "秀水鄉" },
        { "@type": "City", "name": "埔心鄉" },
        { "@type": "City", "name": "埔鹽鄉" },
        { "@type": "City", "name": "大城鄉" },
        { "@type": "City", "name": "芳苑鄉" },
        { "@type": "City", "name": "竹塘鄉" },
        { "@type": "City", "name": "社頭鄉" },
        { "@type": "City", "name": "二水鄉" },
        { "@type": "City", "name": "田尾鄉" },
        { "@type": "City", "name": "埤頭鄉" },
        { "@type": "City", "name": "溪州鄉" }
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "167"
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const changhuaTowns = [
    { name: '彰化市', features: ['彰化車站', '八卦山大佛', '彰化師大'], highlight: true },
    { name: '員林市', features: ['員林車站', '百果山', '員林公園'], highlight: true },
    { name: '鹿港鎮', features: ['鹿港老街', '天后宮', '龍山寺'], highlight: true },
    { name: '和美鎮', features: ['和美工業區', '道東書院', '和美彩繪村'] },
    { name: '北斗鎮', features: ['北斗車站', '奠安宮', '北斗肉圓'] },
    { name: '溪湖鎮', features: ['溪湖糖廠', '巫家捏麵館', '溪湖葡萄'] },
    { name: '田中鎮', features: ['田中車站', '田中森林公園', '贊天宮'] },
    { name: '二林鎮', features: ['二林工商', '仁和宮', '二林蕎麥'] },
    { name: '線西鄉', features: ['線西工業區', '慶安宮', '蛤蜊兵營'] },
    { name: '伸港鄉', features: ['伸港工業區', '福安宮', '伸港海濱'] },
    { name: '福興鄉', features: ['福興工業區', '福寶濕地', '漢寶園'] },
    { name: '秀水鄉', features: ['秀水馬興', '安東教會', '秀水國小'] }
  ];

  const services = [
    {
      icon: 'ri-settings-3-line',
      title: '精密機械搬遷',
      description: '精密機械園區設備搬運專業認證',
      color: 'teal'
    },
    {
      icon: 'ri-building-2-line',
      title: '工廠設備搬遷',
      description: '傳統產業、製造業工廠整廠搬遷',
      color: 'emerald'
    },
    {
      icon: 'ri-seedling-line',
      title: '農業設施搬遷',
      description: '農機具、溫室設備專業搬運服務',
      color: 'green'
    },
    {
      icon: 'ri-ancient-pavilion-line',
      title: '文物古蹟搬遷',
      description: '鹿港古蹟、傳統工藝品安全搬運',
      color: 'cyan'
    }
  ];

  const faqs = [
    {
      question: '彰化搬家公司推薦哪一家？',
      answer: '建鈞精緻搬家服務彰化縣 26 個鄉鎮市，4.8 分高評價，156 則客戶好評，熟悉彰化精密機械園區、傳統產業特色，提供 24 小時免費估價服務。'
    },
    {
      question: '彰化搬家費用怎麼算？',
      answer: '依據搬家規模、樓層、距離計價。套房搬遷 3,000 元起，家庭搬家 3,000-8,000 元，辦公室搬遷 5,000-20,000 元。工廠設備搬遷另行報價，雙邊電梯優惠價 3,000 元起。'
    },
    {
      question: '彰化搬家當天可以預約嗎？',
      answer: '建議提前 3-7 天預約，旺季（週末、月底）建議提前 2 週。工廠設備搬遷建議提前 1 個月規劃。急件可來電 0978-900-081 詢問。'
    },
    {
      question: '彰化精密機械搬遷怎麼處理？',
      answer: '我們有專業的精密機械搬運認證，包含 CNC 工具機、精密量測設備等。提供專業包裝、防震保護、精度校正等服務，確保設備搬運後正常運作。'
    },
    {
      question: '彰化工業區搬家要注意什麼？',
      answer: '彰化有多個工業區（和美、線西、伸港等），我們熟悉各工業區通行規範、作業時間限制。可配合工廠停工時間進行搬遷，確保不影響生產。'
    },
    {
      question: '彰化搬家什麼時間最便宜？',
      answer: '平日（週一至週五）價格較優惠，避開月初、月底、週末、連假等旺季。淡季（1-2月、7-8月）價格更實惠，建議提前規劃搬家時間。'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-orange-50 via-white to-orange-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              彰化搬家公司推薦
            </h1>
            <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
              提供彰化縣26鄉鎮專業搬家服務，24小時全年無休，免費到府估價，專業團隊讓您搬家零煩惱
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link
                to="/quote"
                className="inline-flex items-center px-8 py-3 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                立即預約估價
              </Link>
              <Link
                to="/calculator"
                className="inline-flex items-center px-8 py-3 bg-white text-orange-500 font-semibold rounded-lg border-2 border-orange-500 hover:bg-orange-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-calculator-line mr-2"></i>
                費用試算
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Service Areas */}
      <section className="py-16 bg-gradient-to-br from-teal-50 to-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">彰化縣 26 鄉鎮市完整服務</h2>
            <p className="text-lg text-gray-600">熟悉彰化各鄉鎮產業特色，提供在地化專業搬家服務</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {changhuaTowns.map((town, index) => (
              <div 
                key={index} 
                className={`rounded-xl p-6 transition-all hover:shadow-lg hover:-translate-y-1 ${
                  town.highlight 
                    ? 'bg-gradient-to-br from-teal-50 to-emerald-50 border-2 border-teal-200' 
                    : 'bg-white shadow-md'
                }`}
              >
                <h3 className={`font-bold text-lg mb-3 flex items-center ${
                  town.highlight ? 'text-teal-700' : 'text-gray-900'
                }`}>
                  <i className="ri-map-2-line mr-2"></i>
                  {town.name}
                  {town.highlight && (
                    <span className="ml-2 bg-teal-500 text-white text-xs px-2 py-1 rounded-full">熱門</span>
                  )}
                </h3>
                <div className="space-y-1">
                  {town.features.map((feature, idx) => (
                    <div key={idx} className="text-sm text-gray-600 flex items-center">
                      <i className="ri-checkbox-circle-line text-teal-500 mr-2 text-xs"></i>
                      {feature}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Specialized Services */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">彰化產業特色服務</h2>
            <p className="text-lg text-gray-600">針對彰化精密機械與傳統產業特色，提供專業搬遷解決方案</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service, index) => (
              <div key={index} className="text-center group">
                <div className={`w-20 h-20 bg-${service.color}-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-${service.color}-200 transition-all group-hover:scale-110 shadow-md`}>
                  <i className={`${service.icon} text-3xl text-${service.color}-600`}></i>
                </div>
                <h3 className="font-bold text-lg text-gray-900 mb-2">{service.title}</h3>
                <p className="text-gray-600">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 bg-gradient-to-br from-teal-50 to-emerald-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">彰化搬家常見問題</h2>
              <p className="text-lg text-gray-600">為您解答彰化搬家的各種疑問</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {faqs.map((faq, index) => (
                <div 
                  key={index} 
                  className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all hover:-translate-y-1"
                >
                  <div className="flex items-start gap-3 mb-3">
                    <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-question-line text-teal-600"></i>
                    </div>
                    <h3 className="font-bold text-lg text-gray-900">{faq.question}</h3>
                  </div>
                  <p className="text-gray-600 leading-relaxed pl-11">{faq.answer}</p>
                </div>
              ))}
            </div>

            <div className="text-center mt-8">
              <Link
                to="/faq"
                className="inline-flex items-center gap-2 text-teal-600 hover:text-teal-700 font-semibold transition-colors"
              >
                查看更多常見問題
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Industrial Expertise */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">精密機械搬遷專業</h2>
              <p className="text-lg text-gray-600">專精彰化精密機械產業，提供最專業的工業設備搬遷</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-xl p-6 hover:shadow-lg transition-all hover:-translate-y-1">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-cpu-line text-xl text-teal-600"></i>
                </div>
                <h3 className="font-bold text-lg text-gray-900 mb-3">精密設備搬運</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  專業搬運 CNC 工具機、精密量測設備，確保設備精度不受影響
                </p>
              </div>

              <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl p-6 hover:shadow-lg transition-all hover:-translate-y-1">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-building-4-line text-xl text-blue-600"></i>
                </div>
                <h3 className="font-bold text-lg text-gray-900 mb-3">整廠搬遷規劃</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  製造業整廠搬遷經驗豐富，從拆卸到重新安裝一條龍服務
                </p>
              </div>

              <div className="bg-gradient-to-br from-orange-50 to-yellow-50 rounded-xl p-6 hover:shadow-lg transition-all hover:-translate-y-1">
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-seedling-line text-xl text-orange-600"></i>
                </div>
                <h3 className="font-bold text-lg text-gray-900 mb-3">農機設備搬運</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  農業機械、溫室設備搬運，配合農忙時期彈性調整服務時間
                </p>
              </div>

              <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-6 hover:shadow-lg transition-all hover:-translate-y-1">
                <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-ancient-gate-line text-xl text-purple-600"></i>
                </div>
                <h3 className="font-bold text-lg text-gray-900 mb-3">文化資產保護</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  鹿港古蹟文物、傳統工藝品搬運，專業包裝保護文化資產
                </p>
              </div>

              <div className="bg-gradient-to-br from-indigo-50 to-blue-50 rounded-xl p-6 hover:shadow-lg transition-all hover:-translate-y-1">
                <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-truck-line text-xl text-indigo-600"></i>
                </div>
                <h3 className="font-bold text-lg text-gray-900 mb-3">工業區熟悉</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  和美、線西、伸港等工業區通行規範熟悉，確保搬運順利進行
                </p>
              </div>

              <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-6 hover:shadow-lg transition-all hover:-translate-y-1">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-recycle-line text-xl text-green-600"></i>
                </div>
                <h3 className="font-bold text-lg text-gray-900 mb-3">環保處理認證</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  工業廢料、包材回收處理，符合環保法規要求
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 bg-gradient-to-r from-teal-600 to-emerald-600">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            準備在彰化搬家嗎？
          </h2>
          <p className="text-xl text-teal-100 mb-8">
            立即聯繫我們，獲得專業的彰化精密機械搬家服務評估
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:0978-900-081"
              className="bg-white text-teal-600 hover:bg-teal-50 px-8 py-4 rounded-full font-semibold text-lg transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
            >
              <i className="ri-phone-line"></i>
              電話諮詢：0978-900-081
            </a>
            <a 
              href="https://line.me/ti/p/@285yavdh" 
              target="_blank" 
              rel="noopener noreferrer"
              className="border-2 border-white text-white hover:bg-white hover:text-teal-600 px-8 py-4 rounded-full font-semibold text-lg transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
            >
              <i className="ri-line-fill"></i>
              官方LINE
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
